<div class="pom-container">

  <!-- Header -->
  <div class="pom-header">
    <button class="pom-close" type="button" (click)="activeModal.dismiss()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <span class="pom-badge" translate>Onboarding</span>
    <h2 class="pom-title" translate>Comment fonctionne la plateforme</h2>
    <i class="fa-solid fa-compass pom-header-bg-icon"></i>
  </div>

  <!-- Body -->
  <div class="pom-body">

    <!-- Section 1: parcours -->
    <section class="pom-section">
      <div class="pom-section-head">
        <span class="pom-step-num">1</span>
        <h3 class="pom-section-title" translate>Le parcours d'apprentissage</h3>
      </div>
      <p class="pom-section-desc" translate>
        Tu progresses pas à pas sur un parcours composé de marches. À chaque marche, tu découvres puis tu t'entraînes.
      </p>

      <div class="pom-steps">
        <div class="pom-step">
          <div class="pom-step-icon"><i class="fa-solid fa-book"></i></div>
          <div class="pom-step-body">
            <div class="pom-step-title" translate>Vocabulaire & leçons</div>
            <div class="pom-step-sub" translate>Découvre les mots et les règles à apprendre sur la marche.</div>
          </div>
        </div>
        <div class="pom-step">
          <div class="pom-step-icon"><i class="fa-solid fa-gamepad"></i></div>
          <div class="pom-step-body">
            <div class="pom-step-title" translate>Exercices</div>
            <div class="pom-step-sub" translate>Entraîne-toi avec les jeux pour ancrer ce que tu viens d'apprendre.</div>
          </div>
        </div>
        <div class="pom-step">
          <div class="pom-step-icon pom-step-icon-target"><i class="fa-solid fa-bullseye"></i></div>
          <div class="pom-step-body">
            <div class="pom-step-title" translate>Passage à la marche suivante</div>
            <div class="pom-step-sub">
              <span translate>Il te faut</span>
              <strong class="pom-highlight">&nbsp;80%&nbsp;</strong>
              <span translate>de bonnes réponses minimum sur tous les jeux de la marche.</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section 2: revision -->
    <section class="pom-section">
      <div class="pom-section-head">
        <span class="pom-step-num">2</span>
        <h3 class="pom-section-title" translate>Le module de révision</h3>
      </div>
      <p class="pom-section-desc" translate>
        Depuis ton tableau de bord, retrouve un module dédié pour réviser ton vocabulaire au quotidien.
        Plus tu avances dans le parcours, plus tu as de vocabulaire disponible à réviser.
      </p>
      <div class="pom-callout">
        <i class="fa-solid fa-lightbulb"></i>
        <span translate>Quelques minutes par jour suffisent pour ancrer durablement ce que tu apprends.</span>
      </div>
    </section>

    <!-- Section 3: navigation -->
    <section class="pom-section">
      <div class="pom-section-head">
        <span class="pom-step-num">3</span>
        <h3 class="pom-section-title" translate>Naviguer dans la plateforme</h3>
      </div>
      <p class="pom-section-desc" translate>
        Depuis le menu en haut à droite, tu accèdes à toutes les sections de la plateforme :
      </p>

      <div class="pom-nav-grid">
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-gauge-high"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Tableau de bord</div>
            <div class="pom-nav-sub" translate>Vue d'ensemble de ta progression et accès au module de révision.</div>
          </div>
        </div>
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-route"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Parcours</div>
            <div class="pom-nav-sub" translate>Reprends ton apprentissage là où tu t'es arrêté.</div>
          </div>
        </div>
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-book-open"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Leçons</div>
            <div class="pom-nav-sub" translate>Consulte toutes les leçons disponibles.</div>
          </div>
        </div>
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-earth-europe"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Points culture</div>
            <div class="pom-nav-sub" translate>Découvre les points culture disponibles.</div>
          </div>
        </div>
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-spell-check"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Dictionnaire</div>
            <div class="pom-nav-sub" translate>Retrouve le vocabulaire que tu es en train d'acquérir.</div>
          </div>
        </div>
        <div class="pom-nav-item">
          <div class="pom-nav-icon"><i class="fa-solid fa-chart-line"></i></div>
          <div class="pom-nav-body">
            <div class="pom-nav-title" translate>Statistiques</div>
            <div class="pom-nav-sub" translate>Suis tes statistiques de jeu et ta progression.</div>
          </div>
        </div>
      </div>
    </section>

    <button class="pom-btn-primary" type="button" (click)="activeModal.dismiss()" translate>
      J'ai compris
    </button>

  </div>

</div>
